import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["type", "id", "disabled", "placeholder", "required", "maxlength", "minlength"];
import { computed, ref, watch } from "vue";
import log from "../../services/Logger";
import Icon from "../Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlPassword',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const model = ref(createModel());
        const fieldOptions = props.field.options || {};
        const inputType = computed(() => {
            return revealed.value ? 'text' : 'password';
        });
        const revealed = ref(false);
        function createModel() {
            if (typeof props.data === 'string' || props.data === null || props.data === undefined) {
                return props.data;
            }
            return "" + props.data;
        }
        function reveal() {
            revealed.value = !revealed.value;
        }
        // changes from the outside
        watch(() => props.data, () => model.value = createModel());
        // changes from the inside
        function onChange() {
            let value = model.value;
            if (value === '') {
                value = null;
            }
            log('FieldControlPassword@change', props.field.name, value);
            emit('change', value);
        }
        function onFocus() {
            emit('focus');
        }
        function onBlur() {
            emit('blur');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["form__control secret", { 'form__control--empty': !model.value }])
            }, [
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                    onInput: onChange,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    type: inputType.value,
                    id: __props.fieldId,
                    disabled: _unref(fieldOptions).disabled ?? undefined,
                    placeholder: _unref(fieldOptions).placeholder ?? undefined,
                    required: _unref(fieldOptions).required ?? undefined,
                    maxlength: _unref(fieldOptions).maxLength ?? undefined,
                    minlength: _unref(fieldOptions).minLength ?? undefined,
                    autocomplete: "off",
                    "data-1p-ignore": "",
                    class: "secret__input"
                }, null, 40, _hoisted_1), [
                    [_vModelDynamic, model.value]
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createVNode(Icon, {
                    name: revealed.value ? 'lock-open' : 'lock',
                    class: "secret__icon",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (reveal()), ["prevent"]))
                }, null, 8, ["name"])
            ], 2));
        };
    }
});
